import React, { useState, useEffect } from 'react';
import { Calendar, AlertCircle } from 'lucide-react';
import { HitApi } from '../../../Api/ApiHit';
import { searchTask } from '../../../constant/Constant';
import { getElevateUser, getSelectedUnit } from '../../../storage/Storage';
import MongoosePagination from '../../../components/Pagination/MongoosePagination';
import { useDispatch, useSelector } from 'react-redux';
import { setPagination } from '../../../redux/Actions/TableAction';
import OneTimeTaskCard from '../../../components/Cards/OneTimeTaskCard';

function OneTimeTask({ selectedUserId }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const TableDataReducer = useSelector((state) => state.TableReducer);
  const dispatch = useDispatch();

  // Use selectedUserId if provided (for admin view), otherwise use logged-in user
  const userId = selectedUserId || getElevateUser()?._id;

  useEffect(() => {
    getOneTimeTasks();
  }, [selectedUserId]);

  const getOneTimeTasks = () => {
    const json = {
      page: TableDataReducer.pagination.page,
      limit: TableDataReducer.pagination.limit,
      search: {
        assignedTo: { $in: [userId] },
        taskFrequency: 'once',
        unitIds: getSelectedUnit()?._id,
      },
    };

    HitApi(json, searchTask).then((res) => {
      console.log("One Time Tasks API Response:", res);
      const paginationData = {
        total: res?.data?.totalDocs || 0,
        page: TableDataReducer.pagination.page,
        limit: TableDataReducer.pagination.limit,
      };

      dispatch(setPagination(paginationData));
      if (res.statusCode === 200 && res.data?.docs) {
        setTasks(res.data.docs || []);
      } else {
        setError('Failed to load tasks');
      }
      setLoading(false);
    }).catch((err) => {
      console.error("API Error:", err);
      setError('Error loading tasks');
      setLoading(false);
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">Loading one-time tasks...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center">
          <AlertCircle className="w-5 h-5 text-red-400 mr-2" />
          <span className="text-red-800">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen rounded-xl">
      <div className="mx-auto">
        {tasks.length === 0 ? (
          <div className="text-center py-12">
            <Calendar className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No one-time tasks</h3>
            <p className="text-gray-500">You don't have any one-time tasks assigned.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {tasks.map((task) => (
              <OneTimeTaskCard key={task._id} task={task} />
            ))}
          </div>
        )}
      </div>
      <MongoosePagination />
    </div>
  );
}

export default OneTimeTask;
